import styled from 'styled-components'
import LinkButton from '../../../../../components/LinkButton/LinkButton'

const LeaderboardLink = styled(LinkButton)`
  margin: 20px auto;
  width: 190px;
`

export default LeaderboardLink
